"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mime_types_1 = require("mime-types");
const FileAttribute_1 = require("./FileAttribute");
const FileFastStart_1 = require("./FileFastStart");
class File {
    constructor({ id, originalFileName, url, thumbnailUrl, mimeType, size, fastStart, attribute, }) {
        this.toJSON = () => ({
            id: this.id,
            originalFileName: this.originalFileName,
            url: this.url,
            thumbnailUrl: this.url,
            mimeType: this.mimeType,
            size: this.size,
            fastStart: this.fastStart && this.fastStart.toJSON(),
            attribute: this.attribute.toJSON(),
        });
        if (size <= 0 || !Number.isSafeInteger(size)) {
            throw new Error('size must be an integer greater than 0');
        }
        this.id = id;
        this.originalFileName = originalFileName;
        this.url = url;
        this.thumbnailUrl = thumbnailUrl;
        this.mimeType = mimeType;
        this.size = size;
        this.fastStart = fastStart;
        this.attribute = attribute;
    }
    get extension() {
        const result = mime_types_1.extension(this.mimeType);
        if (!result) {
            throw new Error(`An extension for ${this.mimeType} has no result.`);
        }
        return result;
    }
}
File.fromJSON = (json) => {
    const { id, originalFileName, url, thumbnailUrl, mimeType, size, fastStart, attribute } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof originalFileName !== 'string')
        throw new Error('.originalFileName must be a string');
    if (url != null && typeof url !== 'string')
        throw new Error('.url must be a string');
    if (thumbnailUrl != null && typeof thumbnailUrl !== 'string')
        throw new Error('.thumbnailUrl must be a string');
    if (typeof mimeType !== 'string')
        throw new Error('.mimeType must be a string');
    if (typeof size !== 'number' || Number.isNaN(size))
        throw new Error('.size must be a number');
    const _fileFastStart = fastStart ? FileFastStart_1.default.fromJSON(fastStart) : undefined;
    const fileAttribute = FileAttribute_1.default.fromJSON(attribute);
    return new File({
        id,
        originalFileName,
        url,
        thumbnailUrl,
        mimeType,
        size,
        fastStart: _fileFastStart,
        attribute: fileAttribute,
    });
};
exports.default = File;
